export default __webpack_public_path__ + "static/media/p44.6c60a0dc.jpg";